import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from '../authConfig';
import { NATIVE_AUTH_SESSION_KEY } from '../components/LogoutButton';

/**
 * Call this after any successful native auth flow (login, register, password reset).
 * It marks the session type and forces the standard PublicClientApplication used by
 * AuthComponent to discover the account that native auth wrote to localStorage.
 * Without this, the standard MSAL instance re-initializes on page reload without
 * finding any account and isAuthenticated stays false — forcing a re-login on every visit.
 */
export async function completeNativeAuthSession(loginHint?: string): Promise<void> {
    localStorage.setItem(NATIVE_AUTH_SESSION_KEY, 'true');

    try {
        const stdClient = new PublicClientApplication(msalConfig);
        await stdClient.initialize();

        const accounts = stdClient.getAllAccounts();
        if (accounts.length > 0) {
            stdClient.setActiveAccount(accounts[0]);
            await stdClient.acquireTokenSilent({ ...loginRequest, account: accounts[0] }).catch(() => {});
        } else if (loginHint) {
            await stdClient.ssoSilent({ ...loginRequest, loginHint }).catch(() => {});
        }
    } catch {
        // Non-fatal — worst case user sees login screen once after this visit
    }

    window.location.href = '/';
}
